import { render, staticRenderFns } from "./EditModalTabs.vue?vue&type=template&id=7cb58559&scoped=true&"
import script from "./EditModalTabs.vue?vue&type=script&lang=js&"
export * from "./EditModalTabs.vue?vue&type=script&lang=js&"
import style0 from "./EditModalTabs.vue?vue&type=style&index=0&id=7cb58559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb58559",
  null
  
)

export default component.exports